import React from "react";
import { NavLink } from "react-router-dom";

/** Bannerele de sub antet, comune cojilor Fiord și Purple: licență, pagină veche după o actualizare, starea actualizărilor. */
export default function ShellBanners({ licenseAlert, newBuild, updateBanner }) {
  return (
    <>
      {licenseAlert && (
        <div className="app-banner" style={{ background: "#FEF3C7", borderBottom: "1px solid #FCD34D", fontSize: 13, color: "#92400E" }} data-testid="license-alert">
          {licenseAlert === "inactive"
            ? "Instalarea nu este încă activată — angajatorul și licențele apar automat după activare. "
            : "Licența este blocată: sincronizarea cu furnizorul eșuează de prea mult timp. "}
          <NavLink to="/admin/license" style={{ fontWeight: 700, color: "#92400E" }}>{licenseAlert === "inactive" ? "Activează licența" : "Vezi detalii"}</NavLink>
        </div>
      )}
      {newBuild && (
        <div className="app-banner" style={{ background: "var(--tint-50)", borderBottom: "1px solid var(--tint-200)", fontSize: 13, color: "var(--navy-3)" }} data-testid="new-build-banner">
          Platforma a fost actualizată, dar această pagină încă rulează versiunea veche.{" "}
          <button className="btn btn-secondary" style={{ padding: "2px 10px", marginLeft: 6 }} onClick={() => window.location.reload()}>Reîncarcă pagina</button>
        </div>
      )}
      {updateBanner && (() => {
        const c = { error: ["#FEF2F2", "#FCA5A5", "#991B1B"], ok: ["#F0FDF4", "#86EFAC", "#14532D"], info: ["var(--tint-50)", "var(--tint-200)", "var(--navy-3)"], warn: ["#FFFBEB", "#F59E0B", "#78350F"] }[updateBanner.kind];
        return (
          <div className="app-banner" style={{ background: c[0], borderBottom: `1px solid ${c[1]}`, fontSize: 13, color: c[2] }} data-testid="update-banner">
            {updateBanner.text}{" "}
            {updateBanner.link && <NavLink to="/admin/license" style={{ fontWeight: 700, color: c[2] }}>{updateBanner.link}</NavLink>}
          </div>
        );
      })()}
    </>
  );
}
